if (!customElements.get("header-nav")) {
  class HeaderNav extends HTMLElement {
    constructor() {
      super();

      this.CSSRoot = document.querySelector(":root");
    }

    get height() {
      return parseInt(this.offsetHeight);
    }

    set CSSRootHeight(height) {
      this.CSSRoot.style.setProperty("--nav-height", height + "px");
    }
    
    connectedCallback() {
      this.CSSRootHeight = this.height;

      window.addEventListener("resize", () => this.CSSRootHeight = this.height);
    }
  }
  customElements.define("header-nav", HeaderNav);
}